export default {
  type: "Feature",
  properties: {
    name: "Улиастай",
    location: [47.22701, 96.34754],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [93.42950463294981, 48.42428816283862],
        [93.45108032226561, 48.449243890328724],
        [93.50738525390625, 48.48475582205773],
        [93.57330322265625, 48.510236244324055],
        [93.60076904296875, 48.515694668649466],
        [93.66668701171875, 48.531157010976706],
        [93.67767333984375, 48.600225060468915],
        [93.71063232421875, 48.65468584817256],
        [93.790283203125, 48.68733411186308],
        [93.90838623046875, 48.70908786918211],
        [94.01275634765625, 48.741700879765396],
        [94.09790039062499, 48.79058074474321],
        [94.2132568359375, 48.777912755501845],
        [94.37530517578125, 48.73445537176822],
        [94.537353515625, 48.71452483966839],
        [94.7021484375, 48.7181491602648],
        [94.72686767578125, 48.680080770292875],
        [94.89166259765625, 48.68733411186308],
        [95.0592041015625, 48.68733411186308],
        [95.11962890625, 48.70727541512677],
        [95.23223876953125, 48.77067246880509],
        [95.32562255859375, 48.823140892101684],
        [95.44921875, 48.821332549646634],
        [95.50140380859374, 48.85387273165656],
        [95.526123046875, 48.91708480384719],
        [95.54809570312499, 49.10983779052439],
        [95.58654785156249, 49.19247423824004],
        [95.66070556640625, 49.2337407796959],
        [95.72593688964844, 49.359122687528746],
        [95.66551208496094, 49.39086527280011],
        [95.63117980957031, 49.41856738491886],
        [95.57624816894531, 49.449378780418314],
        [95.52818298339844, 49.46098385110948],
        [95.50483703613281, 49.47615556684203],
        [95.47531127929688, 49.50202588554],
        [95.45677185058594, 49.54481568504451],
        [95.42655944824219, 49.628059153387824],
        [95.41007995605469, 49.71648848390612],
        [95.44990539550781, 49.76618706168036],
        [95.49728393554688, 49.84728146865948],
        [95.49247741699219, 49.86498893140621],
        [95.49316406249999, 49.89109559573688],
        [95.50477266311646, 49.90668648593428],
        [95.50479412078857, 49.906714124882555],
        [95.51925659179688, 49.902595746972025],
        [95.52680969238281, 49.89596137883285],
        [95.53573608398438, 49.89773063286785],
        [95.54466247558594, 49.91055578459883],
        [95.55564880371092, 49.916303883745705],
        [95.56594848632812, 49.948568946378046],
        [95.59341430664062, 49.94901078355837],
        [95.65521240234375, 49.960055395800424],
        [95.66070556640625, 49.97242235423708],
        [95.71563720703125, 49.97065584042108],
        [95.723876953125, 49.988318060767966],
        [95.7513427734375, 49.97242235423708],
        [95.78155517578124, 49.97418880321091],
        [95.77880859375, 49.986552130506176],
        [95.767822265625, 50.004208515595614],
        [95.77880859375, 50.03950183762877],
        [95.82550048828125, 50.04126582312201],
        [95.855712890625, 50.04655739071663],
        [95.9051513671875, 50.0236230514132],
        [95.90789794921875, 49.99538113346378],
        [95.9326171875, 49.986552130506176],
        [95.98480224609374, 49.96888926176223],
        [96.02325439453124, 50.004208515595614],
        [96.08642578125, 50.014799234787844],
        [96.141357421875, 49.98478613540783],
        [96.19903564453125, 49.983020075472226],
        [96.26220703125, 49.97772150663492],
        [96.28143310546875, 49.956521395491166],
        [96.31988525390624, 49.94415035164548],
        [96.33087158203125, 49.94415035164548],
        [96.3555908203125, 49.924703719314344],
        [96.34185791015625, 49.91232450346395],
        [96.4324951171875, 49.87162755709988],
        [96.46270751953125, 49.90701815226818],
        [96.50390625, 49.92293545449574],
        [96.51763916015625, 49.94415035164548],
        [96.55609130859375, 49.938847502925306],
        [96.58355712890625, 49.89463439573421],
        [96.60827636718749, 49.87162755709988],
        [96.64672851562499, 49.88755653624285],
        [96.64947509765625, 49.905249238801304],
        [96.690673828125, 49.914093157463206],
        [96.7291259765625, 49.924703719314344],
        [96.822509765625, 49.908787000867136],
        [96.866455078125, 49.89286502817229],
        [96.98181152343749, 49.89463439573421],
        [97.00927734375, 49.85392252759648],
        [97.01202392578125, 49.83266792683253],
        [97.04498291015624, 49.83266792683253],
        [97.1136474609375, 49.81849300131474],
        [97.12909698486328, 49.80852376975379],
        [97.12532043457031, 49.79988210788039],
        [97.12969779968262, 49.79237479715199],
        [97.12971925735474, 49.79240250154501],
        [97.13630676269531, 49.78392421773299],
        [97.12944030761719, 49.74888708373188],
        [97.10334777832031, 49.68451251348889],
        [97.0751953125, 49.64762521193305],
        [97.03674316406249, 49.61827317596852],
        [96.97425842285155, 49.57821916282],
        [96.93168640136719, 49.542587974015504],
        [96.87538146972656, 49.508714260218404],
        [96.88156127929688, 49.439556958940855],
        [96.87881469726562, 49.36806633482156],
        [96.93374633789062, 49.32422691861083],
        [97.02850341796875, 49.28482762264301],
        [97.119140625, 49.224772722794825],
        [97.174072265625, 49.167338606291075],
        [97.27294921875, 49.182601048138054],
        [97.40478515625, 49.17721484130587],
        [97.52700805664062, 49.157460400911745],
        [97.66983032226562, 49.11343354595957],
        [97.76870727539062, 49.06576863405361],
        [97.85934448242188, 49.009050809382046],
        [97.90054321289062, 48.99733908118444],
        [98.09005737304688, 48.98652581047831],
        [98.13812255859375, 48.99824008113872],
        [98.19442749023438, 49.015355983769666],
        [98.29330444335938, 49.01625665778159],
        [98.36746215820312, 49.01985919086641],
        [98.42926025390625, 49.00094298321501],
        [98.4649658203125, 48.96939999849952],
        [98.54736328125, 48.935130721045326],
        [98.76708984374999, 49.03786794532644],
        [98.800048828125, 49.1170290407793],
        [98.97033691406249, 49.106241774469055],
        [99.1021728515625, 49.1170290407793],
        [99.1461181640625, 49.05227025601607],
        [99.16259765625, 48.88639177703194],
        [99.21203613281249, 48.76343113791796],
        [99.1021728515625, 48.63290858589532],
        [99.06372070312499, 48.494767515307295],
        [99.0966796875, 48.35989909002194],
        [99.0742778778076, 48.296270779257405],
        [99.0743637084961, 48.296099474919146],
        [98.953857421875, 48.27588152743497],
        [98.8385009765625, 48.23747967660676],
        [98.7066650390625, 48.206371336358906],
        [98.6627197265625, 48.16608541901253],
        [98.54736328125, 48.111099041065366],
        [98.4814453125, 48.100094697973795],
        [98.35784912109375, 48.10559716402152],
        [98.27545166015625, 48.09459164290992],
        [98.2232666015625, 48.056053763981225],
        [98.18756103515625, 47.98440682947526],
        [98.20678710937499, 47.91450120703987],
        [98.2012939453125, 47.85187391101592],
        [98.17108154296875, 47.787325537803106],
        [98.19305419921875, 47.706065135695745],
        [98.25347900390624, 47.65428791076272],
        [98.32489013671875, 47.63023101663225],
        [98.41651439666748, 47.61481374692148],
        [98.4166431427002, 47.61490053602275],
        [98.40625762939453, 47.563090772707994],
        [98.37432861328125, 47.52461999690649],
        [98.28369140625, 47.4596655525415],
        [98.272705078125, 47.42065432071321],
        [98.2781982421875, 47.359292508710745],
        [98.2562255859375, 47.27922900257082],
        [98.19580078125, 47.2270293988673],
        [98.13812255859375, 47.200910301521674],
        [98.052978515625, 47.172911278266604],
        [97.96234130859375, 47.18971246448421],
        [97.9046630859375, 47.184112659842015],
        [97.86895751953125, 47.15236927446393],
        [97.8607177734375, 47.08882558740757],
        [97.84423828125, 47.05889641405164],
        [97.75360107421874, 46.9933677428342],
        [97.734375, 46.9446372241817],
        [97.7288818359375, 46.85079989251277],
        [97.69866943359375, 46.758679967095574],
        [97.63824462890625, 46.67205646734499],
        [97.56769180297852, 46.597444318795134],
        [97.56769180297852, 46.597532782686486],
        [97.52906799316406, 46.600628927897176],
        [97.50640869140625, 46.60463891014406],
        [97.48374938964844, 46.61147878308617],
        [97.4593734741211, 46.62350543010974],
        [97.44152069091797, 46.63670808339624],
        [97.42538452148438, 46.64872912635656],
        [97.41302490234375, 46.66357496238209],
        [97.39208221435547, 46.693254407491],
        [97.34813690185547, 46.67559003496991],
        [97.2344970703125, 46.60039303734547],
        [97.18231201171875, 46.57868671298067],
        [97.13836669921874, 46.57679879569828],
        [97.0751953125, 46.581518465658014],
        [97.0257568359375, 46.586237724798856],
        [96.9378662109375, 46.60133659339023],
        [96.92413330078125, 46.65791988638765],
        [96.90078735351562, 46.70314393319737],
        [96.85684204101562, 46.74738913515841],
        [96.81976318359375, 46.79911935722295],
        [96.74972534179688, 46.86113003765812],
        [96.73049926757812, 46.90524554642923],
        [96.69342041015624, 46.92682076739938],
        [96.64535522460938, 46.933385414813976],
        [96.59042358398438, 46.922131240914],
        [96.52656555175781, 46.89163931213447],
        [96.49429321289062, 46.87662152939774],
        [96.40296936035156, 46.849860689868386],
        [96.34185791015625, 46.82731489926434],
        [96.30889892578125, 46.89163931213447],
        [96.29310607910156, 46.933385414813976],
        [96.28005981445312, 46.998987638154624],
        [96.28898620605467, 47.05702528260841],
        [96.2896728515625, 47.09116309620141],
        [96.26701354980469, 47.16637604771991],
        [96.23954772949219, 47.201376826785406],
        [96.19903564453125, 47.23402340128701],
        [96.15577697753905, 47.26804770458176],
        [96.10771179199219, 47.29739357321423],
        [96.05552673339844, 47.301584511330795],
        [96.02119445800781, 47.30949982141431],
        [95.98342895507812, 47.332773275955894],
        [95.91682434082031, 47.37789454155521],
        [95.80284118652344, 47.42669366522116],
        [95.75065612792967, 47.43319679984749],
        [95.59478759765624, 47.51349065484327],
        [95.53024291992188, 47.535746978239125],
        [95.24871826171875, 47.568187190520135],
        [95.0701904296875, 47.54223662718361],
        [95.0482177734375, 47.59690318115471],
        [95.01663208007812, 47.63948497925488],
        [94.97131347656249, 47.65613798222679],
        [94.7735595703125, 47.67648444221321],
        [94.67468261718749, 47.669086647137576],
        [94.47006225585938, 47.68388118858139],
        [94.3011474609375, 47.73932336136857],
        [94.23248291015625, 47.77809779004784],
        [94.185791015625, 47.78548011929362],
        [94.0869140625, 47.76702233051035],
        [93.88092041015625, 47.71530566159559],
        [93.65432739257812, 47.66538735632654],
        [93.6143946647644, 47.65159940883532],
        [93.61443758010864, 47.65159940883532],
        [93.51150512695312, 47.7097615426664],
        [93.39340209960938, 47.77348330190447],
        [93.2684326171875, 47.864773955792245],
        [93.18225860595703, 47.96601978044179],
        [93.240966796875, 48.00094957553023],
        [93.30413818359375, 48.056053763981225],
        [93.3892822265625, 48.10926514749487],
        [93.43666076660156, 48.19950665733754],
        [93.48335266113281, 48.3005532009148],
        [93.4891891479492, 48.32429984442754],
        [93.4881591796875, 48.350773448467265],
        [93.4830093383789, 48.36537369040198],
        [93.47305297851562, 48.377689389945736],
        [93.45245361328125, 48.39615735440508],
        [93.42950999736786, 48.42429528259198],
        [93.42950463294981, 48.42428816283862],
      ],
    ],
  },
};
